// Login Error Codes
export enum LoginErrorCode {
  EMPTY_USERNAME = 'empty_username',
  EMPTY_PASSWORD = 'empty_password',
  INVALID_USERNAME = 'invalid_username',
  INVALID_EMAIL = 'invalid_email',
  INCORRECT_PASSWORD = 'incorrect_password',
  AUTHENTICATION_FAILED = 'authentication_failed',
}

// OTP & Registration Error Codes
export enum AuthErrorCode {
  // Common
  MISSING_PHONE = 'MISSING_PHONE',
  MISSING_OTP = 'MISSING_OTP',
  MISSING_NAME = 'MISSING_NAME',
  MISSING_EMAIL = 'MISSING_EMAIL',
  INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT',
  INVALID_OTP = 'INVALID_OTP',

  // OTP Generate
  INVALID_PHONE_FORMAT = 'INVALID_PHONE_FORMAT',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  SMS_DELIVERY_FAILED = 'SMS_DELIVERY_FAILED',

  // OTP Verify
  OTP_EXPIRED = 'OTP_EXPIRED',
  OTP_NOT_FOUND = 'OTP_NOT_FOUND',
  OTP_NOT_VERIFIED = 'OTP_NOT_VERIFIED',
  MAX_ATTEMPTS_EXCEEDED = 'MAX_ATTEMPTS_EXCEEDED',

  // Email Verification
  EMAIL_NOT_IN_CANDIDATES = 'EMAIL_NOT_IN_CANDIDATES',
  SESSION_NOT_FOUND = 'SESSION_NOT_FOUND',
  SESSION_LOCKED = 'SESSION_LOCKED',

  // Registration
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  CUSTOMER_CREATION_FAILED = 'CUSTOMER_CREATION_FAILED',

  // Google OAuth
  USER_NOT_FOUND = 'USER_NOT_FOUND',
}
